import React, {Fragment, useEffect, useState} from 'react';
import {connect} from "react-redux"
import {mdiInformation, mdiClockTimeFive, mdiCloudDownload, mdiEarth} from "@mdi/js";
import FormState from "./FormState";
import moment from "moment";

const FormsStates = (props) => {

    const [forms, setForms] = useState([])
    useEffect(()=>{
        fetchUserData();

    }, [])

    const fetchUserData = ()=>{

    }

    return (
        <div className={"d-flex flex-column flex-lg-row  p-3 justify-content-center items-center w-100"} style={{ "backgroundColor":"#FFFFFF"}}>
            <FormState  color={"#3FB9AA"} title={"DOSSIER"} filter={null} val={props.vals} subtitle={'Disponible '+moment().format('YYYY')} path={mdiCloudDownload} />
            <FormState  color={"var(--theme-encours)"} title={"EN COURS"} filter={'current'} val={props.vals} subtitle={"Instruction"} path={mdiClockTimeFive} />
            <FormState  color={"var(--theme-urgent)"} title={"URGENT"} filter={"emergency"} val={props.vals} subtitle={"Tacile dans - 8 jours"} path={mdiInformation}  />
            <FormState  color={"var(--theme-portail)"} title={"PORTAIL"} filter={"abonnement"} val={null} subtitle={"Jours restant"} path={mdiEarth} />
        </div>
    )
}

const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
        username : state.MeReducer.username,
        role : state.MeReducer.role,
        currentPage: state.DashboardReducer.current_page
    }
}

const mapDispatchTProps = dispatch => {
    return {
        navigateTo : (e)=> dispatch({type: 'SET_CURRENT_PAGE', data:e}),
        setCurrentCenterPage: (e) => dispatch({type: 'SET_CURRENT_PAGE', data:e}),
        showCenterSection: (e) => dispatch( {type: 'SHOW_CENTER_SECTION', data:e}),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(FormsStates);
